import React, { useState, useEffect } from "react";
import _ from "lodash";
import ReCAPTCHA from "react-google-recaptcha";
import Turnstile, { useTurnstile } from "react-turnstile";
import HCaptcha from '@hcaptcha/react-hcaptcha';

export default function Captcha(props) {
    if (props.type === 'google') {
        return <ReCAPTCHA
            sitekey={props.sitekey}
            onChange={props.onComplete}
        />
    }
    if (props.type === 'turnstile') {
        return <Turnstile
            sitekey={props.sitekey}
            onVerify={props.onComplete}
        />
    }
    if (props.type === 'hcaptcha') {
        return <HCaptcha
            sitekey={props.sitekey}
            onVerify={props.onComplete}
        />
    }

}